import React from "react";
import * as palette from "@govlaunch/palette";
import { FormattedMessage } from "react-intl";
import Strongify from "~/lib/utils/strongify";
import useIntlDate from "~/lib/hooks/useIntlDate";

interface ICurrentBillingScheduledToCancelProps {
  planName: string;
  cancellationDate: any;
}

export default function CurrentBillingScheduledToCancel({
  planName,
  cancellationDate,
}: ICurrentBillingScheduledToCancelProps) {
  const intlDate = useIntlDate();

  return (
    <div
      css={{
        padding: 24,
        backgroundColor: palette.white,
        border: "solid 0.5px #e6e8ea",
        borderRadius: 4,
      }}
    >
      <h1
        css={{
          margin: 0,
          color: "#212121",
          fontWeight: 600,
          fontSize: 20,
        }}
      >
        Billing
      </h1>

      <hr
        css={{
          width: "100%",
          marginTop: 20,
          border: "none",
          borderBottom: `solid 1px #e6e8ea`,
        }}
      />

      <div
        css={{
          paddingTop: 10,
        }}
      >
        <p
          css={{
            margin: 0,
            fontSize: 16,
            lineHeight: 1.33,
            color: "#949195",

            "& > strong": {
              color: palette.text,
              fontWeight: 600,
            },
          }}
        >
          <FormattedMessage
            defaultMessage="Your <strong>{plan}</strong> plan is in the cancellation period and will be cancelled on <strong>{cancellationDate}</strong>. If you would like to reactivate it, you can click on the Reactivate {plan} button above." id="EE4kbk"
            values={{
              plan: planName,
              cancellationDate: intlDate.format(cancellationDate),
              strong: (chunk: any) => Strongify(chunk),
            }}
          />
        </p>
      </div>
    </div>
  );
}
